import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { initializeMonaco } from './app/lib/monaco-setup';

initializeMonaco();

bootstrapApplication(AppComponent, appConfig);
